<template>
  <div id="app">
    <div class="row">
      <div class="col-12">
        <h2 class="generalTitle">Tramos de riesgo</h2>
      </div>
    </div>
    <div class="row mx-1">
      <div class="col-12 mb-3">
        <AddSections @refreshAddRegisterList="refreshAddRegisterList()"/>
      </div>
      <div class="col-12" v-if="sections && sections.length > 0">
        <div class="card" :class="{ 'card-versionMovil': !$store.state.responsive.viewDesktopLists}">
          <div class="card-body pb-0">
            <div class="align-items-center d-flex justify-content-between mb-1">
              <p class="mb-2">Mostrando {{ from }}-{{ to }} de {{ totalItems }} tramos</p>
              <!--<a href="#" data-toggle="modal" data-target="#exportData"><v-icon name="bi-download" scale="1.1" /> DESCARGAR</a>-->
            </div>
            <ListSections :sections="sections"/>
            <div class="row">
              <div class="col-12 col-sm-8 col-lg-5">
                <div class="form-group" v-if="numberPages > 1">
                  <div class="float-left mr-3 mt-2">
                    <select v-model="itemsPerPage" class="form-control" id="itemsPerPage"
                      @change="changeItemsPerPage()">
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label for="itemsPerPage" class="col-form-label mt-2">Tramos por página</label>
                </div>
              </div>
              <div class="col-12 col-sm-4 col-lg-7" v-if="numberPages > 1">
                <pagination :currentPage=currentPage :numberPages=numberPages @selectPage="selectPage($event)" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-else>
        <div class="alert alert-info">No hay resultados para mostrar</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AddSections from './templates/AddSections.vue';
import ListSections from './templates/ListSections.vue';
import Pagination from '@/components/Widgets/Shared/Pagination.vue';
export default {
  name: 'Sections',
  data() {
    return {
      sections: [],
      itemsPerPage: 25,
      currentPage: 0,
      totalItems: 0,
      numberPages: 0,
      from: 0,
      to: 0,
      order: '',
      filters: '',
      username: this.$cookies.get('username'),
    }
  },
  components: {
    AddSections,
    ListSections,
    Pagination
  },
  created() {
    this.loadSections();
  },
  methods: {
    selectPage(value) {
      this.currentPage = value;
      this.$emit("currentParentPage", this.currentPage);
      this.loadSections();
    },
    changeItemsPerPage() {
      this.currentPage = 0;
      this.$emit("currentParentPage", this.currentPage);
      this.loadSections();
    },
    loadSections() {

      const vm = this;
      axios.get(`/application-product-rating/search?pageNumber=${this.currentPage}&pageSize=${this.itemsPerPage}&sort=%2Bstatus`)
        .then((response) => {
          vm.sections = response.data.applicationProductRatings;
          vm.totalItems = response.data.totalElements;
          vm.filters = '';
          vm.numberPages = vm.totalItems % vm.itemsPerPage === 0
            ? vm.totalItems / vm.itemsPerPage
            : parseInt(vm.totalItems / vm.itemsPerPage, 10) + 1;

          vm.from = (vm.currentPage * vm.itemsPerPage) + 1;
          vm.to = (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage > vm.totalItems
            ? vm.totalItems
            : (vm.currentPage * vm.itemsPerPage) + vm.itemsPerPage;

          this.$emit("reloadTable", vm.sections);
          
        });
    },
    refreshAddRegisterList() {
      this.loadSections();
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
